import { render, staticRenderFns } from "./userAgree.vue?vue&type=template&id=0dce8669&scoped=true&"
import script from "./userAgree.vue?vue&type=script&lang=js&"
export * from "./userAgree.vue?vue&type=script&lang=js&"
import style0 from "./userAgree.vue?vue&type=style&index=0&id=0dce8669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce8669",
  null
  
)

export default component.exports